export const getSubscriberProducts = (phoneNumber: string, billingType: string, accountType: string) => {
	return {
		url: `customer-account/customers/subscribed-products/${phoneNumber}/${billingType}/${accountType}`,
	};
};
